import {IconButton, InputAdornment, Typography, typographyClasses, useTheme} from "@mui/material";
import RpIcon from "@/components/RpIcon";
import AppTextField from "@/components/AppTextField";
import React, {useState} from "react";
import { Stack } from "@mui/material";
import { useTranslation } from "react-i18next";

const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,32}$/

const PasswordInput = (props: any) => {

  const {t} = useTranslation();
  const theme = useTheme();
  const [password, setPassword] = useState('');
  const [passwordError, setPasswordError] = useState('');

  const [visiblePassword, setVisiblePassword] = useState(false);
  const handleTogglePasswordVisibility = (field) => {
    setVisiblePassword((prev) => (prev === field ? null : field));
  };
  const [focused, setFocused] = useState(false);
  const [rule1Passed, setRule1Passed] = useState(false);
  const [rule2Passed, setRule2Passed] = useState(false);
  const [rule3Passed, setRule3Passed] = useState(false);
  const [rule4Passed, setRule4Passed] = useState(false);
  // const [rule5Passed, setRule5Passed] = useState(false);

  const _onChange = (e) => {
    console.log('passwordRegex.test(e.target.value)', passwordRegex.test(e.target.value))

    if (e.target.value?.trim().length >= 8 && e.target.value?.trim().length <= 32) {
      setRule1Passed(true)
    } else {
      setRule1Passed(false)
    }

    if (e.target.value?.trim() && /[A-Z]+/.test(e.target.value?.trim())) {
      setRule2Passed(true)
    } else {
      setRule2Passed(false)
    }

    if (e.target.value?.trim() && /[a-z]+/.test(e.target.value?.trim())) {
      setRule3Passed(true)
    } else {
      setRule3Passed(false)
    }

    if (e.target.value?.trim() && /[0-9]+/.test(e.target.value?.trim())) {
      setRule4Passed(true)
    } else {
      setRule4Passed(false)
    }

    // if (e.target.value?.trim() && /[_。%#@]/.test(e.target.value?.trim())) {
    //   setRule5Passed(true)
    // } else {
    //   setRule5Passed(false)
    // }

    if (!passwordRegex.test(e.target.value)) {

    }
    setPassword(e.target.value?.trim());
    props?.onChange && props.onChange(e);
  }

  const _onFocus = (e) => {
    setFocused(true)
    props?.onFocus && props.onFocus(e);
  }

  const _onBlur = (e) => {
    setFocused(false)
    props?.onBlur && props.onBlur(e);
  }

  return (
    <Stack
    sx={{gap: '9px'}}
    >
      <AppTextField
        required
        value={password}
        error={!!passwordError}
        fullWidth
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                onClick={() => handleTogglePasswordVisibility('password1')}
                edge="end"
              >
                {visiblePassword === 'password1' ? (
                  <RpIcon icon="eye_open" size={22} />
                ) : (
                  <RpIcon icon="eye_close" size={22} />
                )}
              </IconButton>
            </InputAdornment>
          ),
        }}
        {...props}
        type={visiblePassword === 'password1' ? 'text' : 'password'}
        onChange={_onChange}
        onFocus={_onFocus}
        onBlur={_onBlur}
      />
      {focused && <Stack
      sx={{
        [`& .${typographyClasses.root}`]: {
          fontSize: '12px !important',
          color: theme.palette.text.tertiary,
        }
      }}
      >
        <Stack direction="row" alignItems="center" gap="4px">
          <RpIcon icon="check-circle" size={16} />
          <Typography
          sx={() => {
            if (rule1Passed) {
              return {
                color: `${theme.palette.text.primary} !important`,
              }
            }
            return {}
          }}
          >{t('password_rule1')}</Typography>
        </Stack>
        <Stack direction="row" alignItems="center" gap="4px">
          <RpIcon icon="check-circle" size={16} />
          <Typography
            sx={() => {
              if (rule2Passed) {
                return {
                  color: `${theme.palette.text.primary} !important`,
                }
              }
              return {}
            }}
          >{t('password_rule2')}</Typography>
        </Stack>
        <Stack direction="row" alignItems="center" gap="4px">
          <RpIcon icon="check-circle" size={16} />
          <Typography
            sx={() => {
              if (rule3Passed) {
                return {
                  color: `${theme.palette.text.primary} !important`,
                }
              }
              return {}
            }}
          >{t('password_rule3')}</Typography>
        </Stack>
        <Stack direction="row" alignItems="center" gap="4px">
          <RpIcon icon="check-circle" size={16} />
          <Typography
            sx={() => {
              if (rule4Passed) {
                return {
                  color: `${theme.palette.text.primary} !important`,
                }
              }
              return {}
            }}
          >{t('password_rule4')}</Typography>
        </Stack>
        {/*<Stack direction="row" alignItems="center">*/}
        {/*  <RpIcon icon="check-circle" size={16} />*/}
        {/*  <Typography*/}
        {/*    sx={() => {*/}
        {/*      if (rule5Passed) {*/}
        {/*        return {*/}
        {/*          color: `${theme.palette.text.primary} !important`,*/}
        {/*        }*/}
        {/*      }*/}
        {/*      return {}*/}
        {/*    }}*/}
        {/*  >{t('password_rule5')}</Typography>*/}
        {/*</Stack>*/}
      </Stack>}
    </Stack>

  )
}

export default PasswordInput